import { useGetMe } from '@/hooks/useGetProfileQuery';
import { createContext, useEffect, useState } from 'react';

type PageSetting = Record<string, number>;

interface PageSettingProvider {
  pageSettings: PageSetting;
  setPageSettings: (values: PageSetting) => void;
}

export const PageSettingsContext = createContext<PageSettingProvider>({
  pageSettings: {},
  setPageSettings: () => {},
});

export const PageSettingsProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const { data: user } = useGetMe();
  const userId = user?.id;
  const key = 'settings-#' + userId;

  const [pageSettings, _setPageSettings] = useState<PageSetting>({});

  useEffect(() => {
    if (userId) {
      _setPageSettings({ ...JSON.parse(localStorage.getItem(key) || '{}') });
    }
  }, [key, userId]);

  const setPageSettings = (values: PageSetting) => {
    _setPageSettings(values);
    localStorage.setItem(key, JSON.stringify(values));
  };

  return (
    <PageSettingsContext.Provider value={{ pageSettings, setPageSettings }}>
      {children}
    </PageSettingsContext.Provider>
  );
};
